import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

export const useGetCountryName = () => {
  const { t, i18n } = useTranslation('countries');

  return useCallback(
    (countryCode: string) => {
      const tKey = `countries:${countryCode}`;

      if (i18n.exists(tKey)) {
        return t('ui:countryWithCode', {
          country: t(tKey),
          code: countryCode,
        });
      }

      return countryCode;
    },
    [i18n, t],
  );
};
